__turbopack_context__.v({
  "divider": "UpsellProducts-module__omBeSW__divider",
  "header": "UpsellProducts-module__omBeSW__header",
  "products": "UpsellProducts-module__omBeSW__products",
  "root": "UpsellProducts-module__omBeSW__root",
});
